import React, { useState, useEffect, Fragment } from 'react';

import { Card, CardBody, CardTitle, Button, Collapse } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { gAPI_Conversations_list } from '../../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import Masking from '../../../../../data/Masking';
import ChatListItem from '../../../../../components/chats/ChatListItem';
import 'react-datepicker/dist/react-datepicker.css';
import ChatMessage from '../../../../../components/chats/ChatMessage';
import messenger_icon from '../../../../../assets/messenger_icon.png';
import website_icon from '../../../../../assets/website_icon.png';
import google_icon from '../../../../../assets/google_icon.png';
import WechatLogo from '../../../../../assets/wechat_icon.png';
import teams from '../../../../../assets/teams.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLock,
  faLockOpen,
  faUserTie,
} from '@fortawesome/free-solid-svg-icons';
import { Badge } from 'reactstrap';
// Helper to fetch agent name by agentID
import { gAPI_userName } from '../../../../../constants/APIs';

const Conversations = ({
  startDate,
  endDate,
  offset,
  items,
  isLoading,
  data,
  agentConversations,
  waitingConversations,
  chatBotConversations,
  activeIndex,
  handleContactClick,
  activeChat,
  pid,
  properties,
  handleMaskClick,
  isMasked,
  isAgentAssist = false,
  imageDomain,
}) => {
  const [conversations, setConversations] = useState(data);
  const [collapse, setCollapse] = useState(false);
  const [agentcollapse, setAgentcollapse] = useState(true);
  const [queuecollapse, setQueuecollapse] = useState(true);
  const [botcollapse, setBotcollapse] = useState(true);
  const [selectedAccordion, setSelectedAccordion] = useState(1);
  const [myconversations, setMyConversations] = useState(
    agentConversations || []
  );
  const [queueconversations, setQueueConversations] = useState(
    waitingConversations || []
  );
  const [botconversations, setBotConversations] = useState(
    chatBotConversations || []
  );
  const [agentNames, setAgentNames] = useState({});
  const fetchAgentName = async (agentID) => {
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: `${gAPI_userName}/${agentID}`,
      });
      return res?.data?.fullName || '';
    } catch (e) {
      return '';
    }
  };

  // Fetch agent names for all agents in conversations
  useEffect(() => {
    const fetchAllAgentNames = async () => {
      let agentIdSet = new Set();
      [myconversations, queueconversations, botconversations].forEach(
        (list) => {
          list.forEach((chat) => {
            if (chat.agents && Array.isArray(chat.agents)) {
              chat.agents.forEach((agentId) => agentIdSet.add(agentId));
            }
          });
        }
      );
      const ids = Array.from(agentIdSet).filter(Boolean);
      const nameMap = {};
      await Promise.all(
        ids.map(async (id) => {
          nameMap[id] = await fetchAgentName(id);
        })
      );
      setAgentNames(nameMap);
    };
    fetchAllAgentNames();
  }, [myconversations, queueconversations, botconversations]);

  //   const [offsetNum, setOffsetNum] = useState(offset || null);
  const [itemsNum, setItemsNum] = useState(items || null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setMyConversations(agentConversations || []);
    setQueueConversations(waitingConversations || []);
    setBotConversations(chatBotConversations || []);
    console.log('chatBotConversations', chatBotConversations);
  }, [
    agentConversations,
    waitingConversations,
    chatBotConversations,
    activeChat,
  ]);

  useEffect(() => {
    const handleSetActive = (e) => {
      try {
        const twilioId = e?.detail?.twilioId;
        if (twilioId) {
          // setActiveChat is in scope in this component
          setActiveChat(twilioId);
        }
      } catch (err) {
        console.warn('Error handling myma_set_active_chat event', err);
      }
    };

    window.addEventListener('myma_set_active_chat', handleSetActive);
    return () => {
      window.removeEventListener('myma_set_active_chat', handleSetActive);
    };
  }, [myconversations]); // include conversations so setActiveChat finds the latest list

  const setActiveChat = (twilioId) => {
    console.log('setActiveChat', twilioId);
    if (agentConversations && agentConversations.length > 0) {
      const chatIndex = agentConversations.findIndex(
        (c) => c.twilioChatId === twilioId
      );
      console.log('chatIndex', chatIndex);
      if (chatIndex !== -1) {
        handleContactClick(
          chatIndex,
          agentConversations[chatIndex].conversationId
        );
      }
    }
  };

  const getImage = (phoneNumber, source) => {
    if (source === 'Phone') {
      if (phoneNumber !== '' && phoneNumber !== undefined) {
        if (
          phoneNumber.startsWith('+6422') ||
          phoneNumber.startsWith('+6427') ||
          phoneNumber.startsWith('+6421') ||
          phoneNumber.startsWith('+6428') ||
          phoneNumber.startsWith('+6429')
        ) {
          return `${imageDomain}/mobile.png`;
        } else {
          return `${imageDomain}/images/landline.png`;
        }
      } else {
        return `${imageDomain}/images/chat.png`;
      }
    } else if (source === 'PhoneSuite') {
      return `${imageDomain}/images/664a7811-8899-4255-8fe8-a12a6bd8b500.png`;
    } else if (source === 'WebsiteDirectLine') {
      return `${imageDomain}/images/2504d2db-ab38-4616-a7ea-d16a4e81bd6f.png`;
    } else if (source === 'GoogleBusinessMessage') {
      return google_icon;
    } else if (source === 'WhatsApp') {
      return `${imageDomain}/images/whatsapp_icon.png`;
    } else if (source === 'FacebookDirectLine') {
      return messenger_icon;
    } else if (source === 'WeChat') {
      return WechatLogo;
    } else if (source === 'TeamsApp') {
      return teams;
    } else {
      return `${imageDomain}/images/chat.png`;
    }
  };

  return (
    <Fragment>
      <Card
        className={`${
          isAgentAssist !== undefined && isAgentAssist == true
            ? 'cardHeightActive ml-2'
            : 'cardHeightActive'
        }`}
        style={{
          overflow: 'scroll',
          marginRight: `${
            isAgentAssist !== undefined && isAgentAssist == true
              ? '0rem'
              : '-1rem'
          }`,
        }}
      >
        <CardBody>
          <div className="scroll">
            {!isLoading ? (
              <Fragment>
                <div className="border">
                  <Button
                    color="link"
                    onClick={() => setAgentcollapse(!agentcollapse)}
                    aria-expanded={agentcollapse}
                  >
                    My Conversations ({myconversations.length})
                  </Button>
                  <Collapse isOpen={agentcollapse}>
                    <div>
                      <div>
                        {myconversations.map((chat, index) => {
                          return (
                            <div
                              key={`chat_${index}`}
                              className={
                                activeChat === chat.conversationId
                                  ? `d-flex flex-row mb-3 border-bottom selectedchat ${
                                      chat.newMessage !== undefined &&
                                      chat.newMessage === true
                                        ? 'blink_me'
                                        : ''
                                    } `
                                  : `d-flex flex-row mb-3 border-bottom ${
                                      chat.newMessage !== undefined &&
                                      chat.newMessage === true
                                        ? 'blink_me'
                                        : ''
                                    } `
                              }
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                handleContactClick(index, chat.conversationId)
                              }
                            >
                              <div className="d-block">
                                <img
                                  src={getImage(chat.phoneNumber, chat.channel)}
                                  alt={'chat'}
                                  className="img-thumbnail border-0 mt-2 ml-2"
                                  style={{ maxWidth: '35px' }}
                                />
                              </div>
                              <div className="pl-3 pt-2 pr-2 pb-2">
                                <div className="pr-4">
                                  {chat.propertyId !== undefined &&
                                    properties !== undefined &&
                                    properties.length > 0 &&
                                    properties.filter(
                                      (p) => p.id === chat.propertyId
                                    ).length > 0 && (
                                      <span
                                        className="badge badge-pill badge-primary
                              position-absolute badge-conversation badge "
                                      >
                                        {
                                          properties.filter(
                                            (p) => p.id === chat.propertyId
                                          )[0].name
                                        }
                                      </span>
                                    )}
                                  {/* Agent badge */}
                                  {chat.agents &&
                                    Array.isArray(chat.agents) &&
                                    chat.agents.length > 0 && (
                                      <div
                                        style={{
                                          marginTop: 4,
                                          display: 'flex',
                                          gap: 6,
                                          flexWrap: 'wrap',
                                        }}
                                      >
                                        {chat.agents.map((agentId) =>
                                          agentNames[agentId] ? (
                                            <Badge
                                              key={agentId}
                                              color="info"
                                              className="d-flex align-items-center"
                                              style={{ marginRight: 0 }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faUserTie}
                                                style={{ marginRight: 4 }}
                                              />
                                              {agentNames[agentId]}
                                            </Badge>
                                          ) : null
                                        )}
                                      </div>
                                    )}
                                  <div className="text-primary text-small font-weight-medium d-none d-sm-block">
                                    {moment(chat.startedUtc).format(
                                      'MMM DD, YYYY h:mm a'
                                    )}
                                    &nbsp; ({chat.visitorMessageCount})
                                  </div>
                                  <p className="mb-2 text-small chat-description">
                                    {chat.detail}
                                  </p>
                                  {chat.phoneNumber != '' && (
                                    <p className="text-muted mb-1 text-small">
                                      {isMasked !== 'true' ? (
                                        <Masking
                                          input={chat.phoneNumber}
                                          inputType={'mobile'}
                                          number={4}
                                        ></Masking>
                                      ) : (
                                        chat.phoneNumber
                                      )}
                                      <span
                                        className="ml-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleMaskClick()}
                                      >
                                        <FontAwesomeIcon
                                          icon={
                                            isMasked === 'true'
                                              ? faLock
                                              : faLockOpen
                                          }
                                          className="fa"
                                        />
                                      </span>
                                    </p>
                                  )}
                                  {chat.email !== '' && (
                                    <p className="text-muted mb-1 text-small">
                                      {isMasked !== 'true' ? (
                                        <Masking
                                          input={chat.email}
                                          inputType={'email'}
                                        ></Masking>
                                      ) : (
                                        chat.email
                                      )}
                                      <span
                                        className="ml-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleMaskClick()}
                                      >
                                        <FontAwesomeIcon
                                          icon={
                                            isMasked === 'true'
                                              ? faLock
                                              : faLockOpen
                                          }
                                          className="fa"
                                        />
                                      </span>
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Collapse>
                </div>
                <div className="border">
                  <Button
                    color="link"
                    onClick={() => setQueuecollapse(!queuecollapse)}
                    aria-expanded={queuecollapse}
                  >
                    Queued Conversations ({queueconversations.length})
                  </Button>
                  <Collapse isOpen={queuecollapse}>
                    <div>
                      <div>
                        {queueconversations.map((chat, index) => {
                          return (
                            <div
                              key={`chat_${index} `}
                              className={
                                activeChat === chat.conversationId
                                  ? 'd-flex flex-row mb-3 border-bottom selectedchat'
                                  : 'd-flex flex-row mb-3 border-bottom'
                              }
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                handleContactClick(index, chat.conversationId)
                              }
                            >
                              <div className="d-block">
                                <img
                                  src={getImage(chat.phoneNumber, chat.channel)}
                                  alt={'chat'}
                                  className="img-thumbnail border-0 mt-2 ml-2"
                                  style={{ maxWidth: '28px' }}
                                />
                              </div>
                              <div className="pl-3 pt-2 pr-2 pb-2">
                                <div className="pr-4">
                                  {chat.propertyId !== undefined &&
                                    properties !== undefined &&
                                    properties.length > 0 &&
                                    properties.filter(
                                      (p) => p.id === chat.propertyId
                                    ).length > 0 && (
                                      <span
                                        className="badge badge-pill badge-primary
                              position-absolute badge-conversation badge "
                                      >
                                        {
                                          properties.filter(
                                            (p) => p.id === chat.propertyId
                                          )[0].name
                                        }
                                      </span>
                                    )}

                                  {/* Agent badge */}
                                  {chat.agents &&
                                    Array.isArray(chat.agents) &&
                                    chat.agents.length > 0 && (
                                      <div
                                        style={{
                                          marginTop: 4,
                                          display: 'flex',
                                          gap: 6,
                                          flexWrap: 'wrap',
                                        }}
                                      >
                                        {chat.agents.map((agentId) =>
                                          agentNames[agentId] ? (
                                            <Badge
                                              key={agentId}
                                              color="info"
                                              className="d-flex align-items-center"
                                              style={{ marginRight: 0 }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faUserTie}
                                                style={{ marginRight: 4 }}
                                              />
                                              {agentNames[agentId]}
                                            </Badge>
                                          ) : null
                                        )}
                                      </div>
                                    )}
                                  <div className="text-primary text-small font-weight-medium d-none d-sm-block">
                                    {moment(chat.startedUtc).format(
                                      'MMM DD, YYYY h:mm a'
                                    )}
                                    &nbsp; ({chat.visitorMessageCount})
                                  </div>
                                  <p className="mb-2 text-small chat-description">
                                    {chat.detail}
                                  </p>
                                  {chat.phoneNumber != '' && (
                                    <p className="text-muted mb-1 text-small">
                                      {isMasked !== 'true' ? (
                                        <Masking
                                          input={chat.phoneNumber}
                                          inputType={'mobile'}
                                          number={4}
                                        ></Masking>
                                      ) : (
                                        chat.phoneNumber
                                      )}
                                      <span
                                        className="ml-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleMaskClick()}
                                      >
                                        <FontAwesomeIcon
                                          icon={
                                            isMasked === 'true'
                                              ? faLock
                                              : faLockOpen
                                          }
                                          className="fa"
                                        />
                                      </span>
                                    </p>
                                  )}
                                  {chat.email !== '' && (
                                    <p className="text-muted mb-1 text-small">
                                      {isMasked !== 'true' ? (
                                        <Masking
                                          input={chat.email}
                                          inputType={'email'}
                                        ></Masking>
                                      ) : (
                                        chat.email
                                      )}
                                      <span
                                        className="ml-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleMaskClick()}
                                      >
                                        <FontAwesomeIcon
                                          icon={
                                            isMasked === 'true'
                                              ? faLock
                                              : faLockOpen
                                          }
                                          className="fa"
                                        />
                                      </span>
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Collapse>
                </div>
                <div className="border">
                  <Button
                    color="link"
                    onClick={() => setBotcollapse(!botcollapse)}
                    aria-expanded={botcollapse}
                  >
                    Ongoing Conversations ({botconversations.length})
                  </Button>
                  <Collapse isOpen={botcollapse}>
                    <div>
                      <div>
                        {botconversations.map((chat, index) => {
                          return (
                            <div
                              key={`chat_${index} `}
                              className={
                                activeChat === chat.conversationId
                                  ? 'd-flex flex-row mb-3 border-bottom selectedchat'
                                  : 'd-flex flex-row mb-3 border-bottom'
                              }
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                handleContactClick(index, chat.conversationId)
                              }
                            >
                              <div className="d-block">
                                <img
                                  src={getImage(chat.phoneNumber, chat.channel)}
                                  alt={'chat'}
                                  className="img-thumbnail border-0 mt-2 ml-2"
                                  style={{ maxWidth: '28px' }}
                                />
                              </div>
                              <div className="pl-3 pt-2 pr-2 pb-2">
                                <div className="pr-4">
                                  {chat.propertyId !== undefined &&
                                    properties !== undefined &&
                                    properties.length > 0 &&
                                    properties.filter(
                                      (p) => p.id === chat.propertyId
                                    ).length > 0 && (
                                      <span
                                        className="badge badge-pill badge-primary
                              position-absolute badge-conversation badge"
                                      >
                                        {
                                          properties.filter(
                                            (p) => p.id === chat.propertyId
                                          )[0].name
                                        }
                                      </span>
                                    )}
                                  {/* Agent badge */}
                                  {chat.agents &&
                                    Array.isArray(chat.agents) &&
                                    chat.agents.length > 0 && (
                                      <div
                                        style={{
                                          marginTop: 4,
                                          display: 'flex',
                                          gap: 6,
                                          flexWrap: 'wrap',
                                        }}
                                      >
                                        {chat.agents.map((agentId) =>
                                          agentNames[agentId] ? (
                                            <Badge
                                              key={agentId}
                                              color="info"
                                              className="d-flex align-items-center"
                                              style={{ marginRight: 0 }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faUserTie}
                                                style={{ marginRight: 4 }}
                                              />
                                              {agentNames[agentId]}
                                            </Badge>
                                          ) : null
                                        )}
                                      </div>
                                    )}
                                  <div className="text-primary text-small font-weight-medium d-none d-sm-block">
                                    {moment(chat.startedUtc).format(
                                      'MMM DD, YYYY h:mm a'
                                    )}
                                    &nbsp; ({chat.visitorMessageCount})
                                  </div>
                                  <p className="mb-2 text-small chat-description">
                                    {chat.detail}
                                  </p>
                                  {chat.phoneNumber != '' && (
                                    <p className="text-muted mb-1 text-small">
                                      {isMasked !== 'true' ? (
                                        <Masking
                                          input={chat.phoneNumber}
                                          inputType={'mobile'}
                                          number={4}
                                        ></Masking>
                                      ) : (
                                        chat.phoneNumber
                                      )}
                                      <span
                                        className="ml-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleMaskClick()}
                                      >
                                        <FontAwesomeIcon
                                          icon={
                                            isMasked === 'true'
                                              ? faLock
                                              : faLockOpen
                                          }
                                          className="fa"
                                        />
                                      </span>
                                    </p>
                                  )}
                                  {chat.email !== '' && (
                                    <p className="text-muted mb-1 text-small">
                                      {isMasked !== 'true' ? (
                                        <Masking
                                          input={chat.email}
                                          inputType={'email'}
                                        ></Masking>
                                      ) : (
                                        chat.email
                                      )}
                                      <span
                                        className="ml-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleMaskClick()}
                                      >
                                        <FontAwesomeIcon
                                          icon={
                                            isMasked === 'true'
                                              ? faLock
                                              : faLockOpen
                                          }
                                          className="fa"
                                        />
                                      </span>
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Collapse>
                </div>
              </Fragment>
            ) : (
              <div className="loading" />
            )}
          </div>

          {loading && (
            <div
              style={{ textAlign: 'center', fontSize: '16px', margin: '8px 0' }}
            >
              Loading ...
            </div>
          )}
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default Conversations;
